import $ from 'jquery';

$(_ => {

  $('.js-dialog-person-detail').on('click', function() {
    const $el = $(this);
    const name = $el.attr('data-person-name');
    const id = $el.attr('data-id');
    lDialog.open({
      title: name,
      className: 'l-dialog--person-detail',
      autofocusFirstFocusableElement: false,
      ajax: {
        url: '/h/app/ShowDialogPersonDetail',
        data: { id }
      }
    });
  });

});